import { render, staticRenderFns } from "./YouthMatch.vue?vue&type=template&id=7830fda6&scoped=true&"
import script from "./YouthMatch.vue?vue&type=script&lang=js&"
export * from "./YouthMatch.vue?vue&type=script&lang=js&"
import style0 from "./YouthMatch.vue?vue&type=style&index=0&id=7830fda6&lang=stylus&scoped=true&"
import style1 from "./YouthMatch.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7830fda6",
  null
  
)

export default component.exports